export const environment = {
    api: 'https://api.dev.tk.omniflou.com',
    // ID de la compañía para la que se hace soporte (configurar según cliente)
    companyId: '68c1819f4e0f5f04af626fcc', // TODO: Configurar con el ObjectId de la compañía
};
